module.exports = __webpack_public_path__ + "img/2200.d84228fb.jpg";